import { types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

export const SingleCardSwiperStore = t
  .model('SingleCardSwiperStore', {
    currentSlideIndex: t.optional(t.number, 0),
    slideCount: t.optional(t.number, 0),
  })
  .volatile(() => ({
    swiperRef: null,
  }))
  .views((self) => ({
    get canPrev() {
      return self.currentSlideIndex > 0;
    },
    get canNext() {
      return self.currentSlideIndex < self.slideCount - 1;
    },
  }))
  .actions((self) => ({
    registerSwiper(ref) {
      self.swiperRef = ref;
    },
    resetSlideIndex() {
      self.swiperRef.swiper.slideTo(0, 0);
      self.currentSlideIndex = 0;
    },
    setSlideCount(newSlideCount) {
      self.slideCount = newSlideCount;
    },
    setSlideIndex(newIndex) {
      self.currentSlideIndex = newIndex;
    },
    nextSlide() {
      if (!self.canNext) return;
      if (self.swiperRef) {
        // self.currentSlideIndex += 1;
        self.swiperRef.swiper.slideTo(self.currentSlideIndex + 1, 200);
      }
    },
    prevSlide() {
      if (!self.canPrev) return;
      if (self.swiperRef) {
        // self.currentSlideIndex -= 1;
        self.swiperRef.swiper.slideTo(self.currentSlideIndex - 1, 200);
      }
    },
  }));

export const useSingleCardSwiperStore = () => {
  return useStore(SingleCardSwiperStore);
};

export const withSingleCardSwiperStore = (Component: any) => (props: any) => {
  const quizzListInputCreateStore = useCreateStore(SingleCardSwiperStore);
  const SingleCardSwiperStoreProvider = useProvider(SingleCardSwiperStore);

  return (
    <SingleCardSwiperStoreProvider value={quizzListInputCreateStore}>
      <Component {...props} />
    </SingleCardSwiperStoreProvider>
  );
};
